import MuiAlert, { type AlertProps } from "@mui/material/Alert";
import type { ReactNode } from "react";

import styles from "./AlertV2.module.css";

import { IconV2, type IconV2Name } from "@/components/atoms/IconV2";

type Severity = NonNullable<AlertProps["severity"]>;

// Iconos Lucide del UI Kit, no los Material de MUI por defecto (spec Figma
// node-id=525-19): zap/circleCheck/triangleAlert/circleAlert por severidad.
const SEVERITY_ICON: Record<Severity, IconV2Name> = {
  info: "zap",
  success: "circleCheck",
  warning: "triangleAlert",
  error: "circleAlert",
};

const CloseIcon = () => <IconV2 name="close" />;

type Props = Pick<
  AlertProps,
  "severity" | "onClose" | "children" | "action"
> & {
  expandedContent?: ReactNode;
};

export const AlertV2 = ({
  severity = "info",
  expandedContent,
  ...props
}: Props) => (
  <div className={styles.wrapper} data-severity={severity}>
    <MuiAlert
      className={styles.alert}
      classes={{
        icon: styles.icon,
        message: styles.message,
        action: styles.action,
      }}
      severity={severity}
      variant="standard"
      icon={<IconV2 name={SEVERITY_ICON[severity]} size="l" />}
      slots={{ closeIcon: CloseIcon }}
      {...props}
    />
    {expandedContent}
  </div>
);
